import _ from 'lodash'
import moment from 'moment'
import DatePicker from './DatePicker'
import toast from './Toast'
import { SelectCreatable, SelectSimple } from './Select'
import { useSetState } from '../utils'
import api from '../api'
import { useState } from 'react'

let EmailLeads = ({ onClose, clients }) => {
  let [sending, setSending] = useState(false)
  let [{ clientId, fromDate, toDate, emailAddresses }, setState] = useSetState({
    clientId: 'EGL',
    fromDate: moment().subtract(1, 'month').startOf('month').valueOf(),
    toDate: moment().subtract(1, 'month').endOf('month').valueOf(),
    emailAddresses: [],
  })

  return (
    <div>
      <div className="form-row">
        <div className="form-group col-md-3">
          <label>Client</label>
          <SelectSimple
            placeholder="-- Select --"
            options={clients.map(({ id, name }) => ({
              label: `${id}-${name}`,
              value: id,
            }))}
            value={clientId}
            onChange={newClientId => {
              setState({
                clientId: newClientId,
                emailAddresses: _.chain(clients)
                  .find({ id: newClientId })
                  .get('reportEmailAddresses')
                  .map(label => ({ label, value: label }))
                  .value(),
              })
            }}
          />
        </div>
        <div className="form-group col-md-2">
          <label>From</label>
          <DatePicker
            date={fromDate}
            onChange={d =>
              setState({ fromDate: moment(d).startOf('day').valueOf() })
            }
          />
        </div>
        <div className="form-group col-md-2">
          <label>To</label>
          <DatePicker
            date={toDate}
            onChange={d =>
              setState({ toDate: moment(d).endOf('day').valueOf() })
            }
          />
        </div>
        <div className="form-group col-md-5">
          <label>Email Addresses</label>
          <SelectCreatable
            options={[]}
            isMulti
            className="bg-white"
            onChange={newValue => setState({ emailAddresses: newValue })}
            value={emailAddresses}
            noOptionsMessage={() => 'Enter Email Address'}
          />
        </div>
      </div>
      <div className="mt-2 d-flex justify-content-end">
        <button
          className="ml-auto btn btn-secondary"
          disabled={sending}
          onClick={async () => {
            try {
              setSending(true)
              await api('/email-leads-report', {
                clientId,
                fromDate,
                toDate,
                emailAddresses: _.map(emailAddresses, 'value'),
              })
              toast.success('The leads email has been triggered successfulluy')
              onClose()
            } catch (e) {
              toast.error(`Error sending email: ${e}`)
              setSending(false)
            }
          }}
        >
          <i className="fa fa-paper-plane" /> Send Email
        </button>
      </div>
    </div>
  )
}

export default EmailLeads
